/**
 * Carton quantity helpers.
 *
 * The units-per-carton value is provided by the Xhosa API (product.cartonQuantity), which derives it
 * from the same BoxPacker engine that calculates real shipment carton counts (e.g. ~10 for Classic
 * C2G). These helpers only normalise that value — there is intentionally NO SKU-pattern guessing.
 */

export function getCartonQuantity(cartonQuantity?: number | null): number {
  return cartonQuantity && cartonQuantity > 0 ? cartonQuantity : 1
}

export function shouldShowCartonQuantity(cartonQuantity?: number | null): boolean {
  return getCartonQuantity(cartonQuantity) > 1
}
